// ENUMS #############################################################
// API enums *********************************************************
export enum FccDataCenterStatusEnum {
	DELETED = 'deleted',
	FAILED = 'failed',
	INSTALLING = 'installing',
	SUCCESS = 'success'
}

// UI enums *********************************************************


// TYPES #############################################################
export type FccDatacenterProp = ( keyof FccDatacenter );
export type FccDatacenterProps = FccDatacenterProp[];

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TMO - TransitionalModelObject)
export class FccDatacenterTMO {
	public apiKey?: string = undefined;
	public installationStatus?: FccDataCenterStatusEnum = undefined;
	public installationTriggerDate?: Date = undefined;
	public url?: string = undefined;
}

export class FccDataCenterApiKeyTMO {
	public apiKey?: string = undefined;
}


// APP MODEL (EMO - EntityModelObject)
export class FccDatacenter extends FccDatacenterTMO {}

export class FccDataCenterApiKey extends FccDataCenterApiKeyTMO {}
